export enum SocketStatuses {
  CONNECTED = "connected",
  DISCONNECTED = "disconnected",
  CONNECTING = "connecting",
  UNAVAILABLE = "unavailable",
  FAILED = "failed",
}

export type NewCurrentAgendaSectionEvent = {
  section_id: number;
  datetime: string;
  previous_id: number;
};

export type NewCurrentAgendaSubsectionEvent = {
  subsection_id: number;
  datetime: string;
  previous_id: number;
};

export type LiveAgendaFinishedEvent = {
  last_section_id: number;
  last_subsection_id: number;
  datetime: string;
};

export type ChangedCurrentAgendaItemEvent = {
  current_section_id: number;
  current_subsection_id: number;
  previous_section_id: number;
  previous_subsection_id: number;
  datetime: string;
};

export type PermissionChangedEvent = {
  role_id: number;
  role_type: string;
};

export type MilestoneRequirementChangedEvent = {
  meeting_id: number;
  requirement_id: number;
  completed: boolean;
  datetime: string;
};

export type MeetingNoteLockedEvent = {
  datetime: string;
  meeting_id: number;
  note_id: number;
  section_id: number;
  section_class: "AgendaSection" | "AgendaSubsection";
  editor_id: number | null;
};

export type MeetingNoteUnlockedEvent = {
  datetime: string;
  meeting_id: number;
  note_id: number;
  section_id: number;
  section_class: "AgendaSection" | "AgendaSubsection";
  editor_id: undefined;
};

export enum SocketEvents {
  MeetingStarted = ".Domain\\Meeting\\Events\\MeetingStarted",
  NewCurrentAgendaSection = ".Domain\\Meeting\\Events\\NewCurrentAgendaSection",
  NewCurrentAgendaSubsection = ".Domain\\Meeting\\Events\\NewCurrentAgendaSubsection",
  ChangedCurrentAgendaItem = ".Domain\\Meeting\\Events\\ChangedCurrentAgendaItem",
  LiveAgendaFinished = ".Domain\\Meeting\\Events\\LiveAgendaFinished",
  VotingStarted = ".Domain\\Voting\\Events\\VotingStarted",
  VotingEnded = ".Domain\\Voting\\Events\\VotingEnded",
  VotingVote = ".Domain\\Voting\\Events\\VoteCastByUser",
  VoteCast = ".Domain\\Voting\\Notifications\\VoteCast",
  VotingResultChanged = ".Domain\\Voting\\Events\\VotingResultChanged",
  PermissionChanged = ".Domain\\Auth\\Events\\PermissionsChanged",
  UserEndedMeeting = ".Domain\\Meeting\\Events\\UserEndedMeeting",
  MilestoneRequirementChanged = ".Domain\\Meeting\\Events\\MilestoneRequirementChanged",
  UserJoinedVoting = ".Domain\\Voting\\Events\\UserJoinedVoting",
  UserRejectedVotingInvitation = ".Domain\\Voting\\Events\\UserRejectedVotingInvitation",
  MeetingNoteLocked = ".Domain\\Meeting\\Events\\NoteLocked",
  MeetingNoteUnlocked = ".Domain\\Meeting\\Events\\NoteUnlocked",
  StreamingPermissionRequest = ".Domain\\VideoCall\\Events\\StreamingPermissionRequest",
  StreamingPermissionGranted = ".Domain\\VideoCall\\Events\\StreamingPermissionGranted",
  MeetingNotes = ".Domain\\Meeting\\Events\\MeetingMinutesNote",
}
